module.exports = __webpack_public_path__ + "img/Lixin_Duan@2x.cad58c2a.png";